export default "__VITE_ASSET__rG$2Mesr__"